import React from 'react'
import { StudioProject } from '@/lib/react-query'
import { Body, Cell, Head, HeaderCell, Row as TableRow, Table } from '@/components/ui/Table'
import Section from '@/components/ui/Section'
import { ReactComponent as CodeIcon } from '@/assets/icons/code.svg'
import classes from './Dashboard.module.scss'
import RouteItem from './RouteItem'
import { useSortedRoutes } from '@/app/routes/Dashboard/ProjectSection.hooks'
import CreateRouteButton from '@/app/routes/Dashboard/CreateRouteButton'
import { useStartPreferredRoute } from '@/app/routes/Dashboard/CreateRouteButton/CreateRouteButton.hooks'

export type Props = {
  title: string
  project: StudioProject
}

const ProjectSection = ({ project, title }: Props) => {
  const [routes, isLoading] = useSortedRoutes(project.id!)
  const [startPreferredRoute, isNewLoading] = useStartPreferredRoute(project.id!)

  return (
    <Section className={classes.section}>
      <Section.Header title={title} icon={<CodeIcon />}>
        <CreateRouteButton onCreate={startPreferredRoute} isLoading={isNewLoading} />
      </Section.Header>
      <Section.Content isLoading={isLoading}>
        <Table>
          <Head>
            <HeaderCell size={3}>Name</HeaderCell>
            <HeaderCell>Language</HeaderCell>
            <HeaderCell>Type</HeaderCell>
            <HeaderCell>Created at</HeaderCell>
            <HeaderCell>Updated at</HeaderCell>
            <HeaderCell size={'80px'} isCentered>
              Active
            </HeaderCell>
            <HeaderCell size={'80px'} isCentered>
              Delete
            </HeaderCell>
          </Head>
          <Body>
            {routes.map((route) => (
              <RouteItem key={route.id} route={route} projectId={project.id!} />
            ))}

            {routes.length === 0 && (
              <TableRow>
                <Cell>No routes created yet</Cell>
              </TableRow>
            )}
          </Body>
        </Table>
      </Section.Content>
    </Section>
  )
}

export default ProjectSection
